import { Attributes, Validation } from '@singularsystems/neo-core';
import APIModelBase from '../Library/APIModelBase';

export default class InvestorTypeSectionConfig extends APIModelBase {
    static typeName = "InvestorTypeSectionConfig";

    constructor() {
        super();
        this.makeObservable();
    }

    public displayLabel: string = "";

    public isVisible: boolean = false;

    @Attributes.Integer()
    public displayOrder: number = 0;

    public sectionKey: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InvestorTypeSectionConfig>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.displayLabel) {
            return "New investor type section config";
        } else {
            return this.displayLabel;
        }
    }
}